import { useMemo } from 'react';

import { useNewUserAccessRights } from '@app/hooks';

import type { MenuProps } from 'antd';

interface Props {
  openPaymentsModal(): void;
  openCollectionsModal(): void;
  openExpensesModal(): void;
}

export const useDropdownItems = ({
  openPaymentsModal,
  openCollectionsModal,
  openExpensesModal,
}: Props) => {
  const {
    userAccessRights: {
      SalesRegister: { IsCreateExpense, IsCreateCollection, IsToppingUpCash },
    },
  } = useNewUserAccessRights();

  const items: MenuProps['items'] = useMemo(
    () => [
      ...(IsToppingUpCash
        ? [
            {
              key: '1',
              label: (
                <div
                  onClick={openPaymentsModal}
                  data-testid="add-cash-replenishment"
                >
                  Добавить пополнение кассы
                </div>
              ),
            },
          ]
        : []),
      ...(IsCreateCollection
        ? [
            {
              key: '2',
              label: (
                <div
                  onClick={openCollectionsModal}
                  data-testid="add-cash-collection"
                >
                  Добавить инкассацию
                </div>
              ),
            },
          ]
        : []),
      ...(IsCreateExpense
        ? [
            {
              key: '3',
              label: (
                <div onClick={openExpensesModal} data-testid="add-expense">
                  Добавить расход
                </div>
              ),
            },
          ]
        : []),
    ],
    [
      openPaymentsModal,
      openCollectionsModal,
      openExpensesModal,
      IsCreateCollection,
      IsCreateExpense,
      IsToppingUpCash,
    ]
  );

  return { items };
};
